var $273b1d5ecf07fe52$exports = {};
$273b1d5ecf07fe52$exports = {
    "loading": `Chargement...`,
    "loadingMore": `Chargement suppl\xe9mentaire...`
};


export {$273b1d5ecf07fe52$exports as default};
//# sourceMappingURL=fr-FR.module.js.map
